import {
  createBrand,
  updateBrand,
  getBrandById,
  getBrands,
} from "@/services/admin/brands";

export const state = {
  brands: [],
  currentBrand: {
    name: "",
    slug: "",
    image: "",
    status: "",
  },
  formData: {
    name: "",
    slug: "",
    image: "",
    status: "active",
  },
  isUploading: false,
};

export const mutations = {
  SET_BRANDS(state, brands) {
    state.brands = brands;
  },
  SET_CURRENT_BRAND(state, brand) {
    state.currentBrand = brand;
    state.formData = { ...brand };
  },
  UPDATE_FORM_DATA(state, { field, value }) {
    state.formData = {
      ...state.formData,
      [field]: value,
    };
  },
  SET_UPLOADING_STATUS(state, status) {
    state.isUploading = status;
  },
  RESET_FORM(state) {
    state.formData = {
      name: "",
      slug: "",
      image: "",
      status: "active",
    };
  },
};

export const actions = {
  async fetchBrands({ commit }) {
    try {
      const response = await getBrands(1, 1000);
      commit("SET_BRANDS", response.data.data);
    } catch (error) {
      console.error("Failed to fetch brands:", error);
      throw error;
    }
  },

  async loadBrandById({ commit }, id) {
    try {
      const response = await getBrandById(id);
      const brand = {
        name: response.data.name,
        slug: response.data.slug,
        image: response.data.image,
        status: response.data.status,
      };
      commit("SET_CURRENT_BRAND", brand);
    } catch (error) {
      console.error("Failed to load brand:", error);
      throw error;
    }
  },

  async saveBrand({ commit }, { id = null, formData }) {
    try {
      if (id) {
        await updateBrand(id, formData);
      } else {
        await createBrand(formData);
      }
      commit("RESET_FORM");
      return true;
    } catch (error) {
      console.error("Failed to save brand:", error);
      throw error;
    }
  },

  updateFormField({ commit }, { field, value }) {
    commit("UPDATE_FORM_DATA", { field, value });
  },
};

export const getters = {
  isNameDuplicate: (state) => (name) => {
    return state.brands.some(
      (brand) => brand.name.toLowerCase() === name.toLowerCase()
    );
  },
  isSlugDuplicate:
    (state) =>
    (slug, currentId = null) => {
      return state.brands.some(
        (brand) =>
          brand.slug.toLowerCase() === slug.toLowerCase() &&
          (!currentId || brand.id !== currentId)
      );
    },
};
